// battleUtils.js
// Single source of truth for battle-related UI constants and components
// Used by: BattlePage, BattleArena, HistoryPage, MatchmakingOverlay

import React from 'react';

// ─── Tier config ──────────────────────────────────────────────────────────────
export const TIER = [
  { min: 2000, label: 'Prompt Legend',    color: '#F59E0B', icon: '👑' },
  { min: 1800, label: 'Prompt Master',    color: '#8B5CF6', icon: '🔮' },
  { min: 1600, label: 'Prompt Architect', color: '#06B6D4', icon: '⚡' },
  { min: 1400, label: 'Prompt Engineer',  color: '#10B981', icon: '🛠' },
  { min: 1200, label: 'Apprentice',       color: '#3B82F6', icon: '📖' },
  { min: 0,    label: 'Rookie',           color: '#6B7280', icon: '🌱' },
];

export const getTier = (elo) => TIER.find(t => elo >= t.min) || TIER[TIER.length - 1];

// ─── Avatar — initials-based, no external requests ───────────────────────────
const AVATAR_COLORS = [
  '#6366F1','#8B5CF6','#EC4899','#EF4444',
  '#F59E0B','#10B981','#06B6D4','#3B82F6',
  '#F97316','#84CC16',
];

export const getInitialsData = (seed = 'default') => {
  const name    = seed === 'default' ? '?' : seed;
  const words   = name.trim().split(/\s+/);
  const initials = words.length >= 2
    ? (words[0][0] + words[words.length - 1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();

  // Deterministic color from seed so same username always gets same color
  const idx   = [...name].reduce((acc, c) => acc + c.charCodeAt(0), 0) % AVATAR_COLORS.length;
  const color = AVATAR_COLORS[idx];

  return { initials, color };
};

export const Avatar = ({ seed, size = 32, className = '' }) => {
  const { initials, color } = getInitialsData(seed || 'default');
  const fontSize = Math.round(size * 0.38);
  return (
    <div
      className={className}
      style={{
        width:          size,
        height:         size,
        borderRadius:   '50%',
        background:     color,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        flexShrink:     0,
        fontWeight:     700,
        fontSize,
        color:          '#fff',
        userSelect:     'none',
        letterSpacing:  '0.02em',
      }}
    >
      {initials}
    </div>
  );
};